import * as MobileDetect from 'mobile-detect';

export const isMobile = () => {
  const md = new MobileDetect(window.navigator.userAgent);
  return !!md.mobile();
};
